
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forecasting/create",
      function () {
        return require("private-next-pages/forecasting/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forecasting/create"])
      });
    }
  